import { render, staticRenderFns } from "./PFormInputTextSearch.vue?vue&type=template&id=11f5a2a6&scoped=true&"
import script from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputTextSearch.vue?vue&type=style&index=0&id=11f5a2a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f5a2a6",
  null
  
)

export default component.exports